import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../assets/img/logo.png';

function AuthHeader() {
    const publicUrl = process.env.REACT_APP_PUBLIC_URL;
    return (
        <>
            <div className="auth__header">
                <div className="container">
                    <div className='logo text-center'>
                        <Link to={publicUrl}>
                            <img src={logo} alt='Cardplot logo' />
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AuthHeader